import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Wrapper = styled.section`
  margin: 0 auto;
  width: 100%;
  min-height: 5em;
  padding: 2em 1.5em 2em;
  @media (max-width: ${props => props.theme.responsive.small}) {
    padding: 2em 1.3em 2em;
  }
`

const Container = props => {
    return <Wrapper className={props.className}>{props.children}</Wrapper>
}

Container.propTypes = {
    className: PropTypes.string,
    children: PropTypes.object
}

export default Container
